import styled from "@emotion/styled";

export const CancelContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  gap: 20px;
  overflow-y: auto;
  overflow-x: visible;
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
  align-items: center;
  border-bottom: 1px solid var(--color-line-normal, #e4e5e7);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RowFormContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
